export default __webpack_public_path__ + "static/media/oops.97508aa9.png";